import { IconProps } from './IconProps';

export const UpArrowGreen_Trend = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7527 4.08455L21.8742 12.2149C22.327 12.6681 22.3266 13.4026 21.8733 13.8553C21.6558 14.0726 21.361 14.1946 21.0536 14.1946L4.8106 14.1946C4.16997 14.1946 3.65063 13.6753 3.65063 13.0347C3.65063 12.7272 3.77267 12.4324 3.98993 12.2149L12.1114 4.08455C12.5642 3.63131 13.2995 3.63181 13.7527 4.08455C13.753 4.08485 13.7524 4.08426 13.7527 4.08455ZM8.27027 14.1946L17.5939 14.1946L15.9061 20.0739C15.5254 21.4004 14.3121 22.3144 12.9321 22.3144C11.552 22.3144 10.3388 21.4004 9.95802 20.0739L8.27027 14.1946Z"
        fill="#05FF00"
      />{' '}
    </svg>
  );
};
